import { Box, Typography } from "@mui/material";

import { ds } from "../theme/ds";
import type { WidgetProps } from "./types";

import { Card, CardLabel } from "./live/card";

// The metrics a partnership is measured on, as a glossary of cards (exclusivity
// pitch room Metrics page, Elijah 2026-10-27; the KPI list Bill sent Jofran on
// 2026-01-16). Groups carry a small uppercase label; each metric is a card with
// its name, what it measures and which direction is good, so a supplier can read
// the monthly report against it.
export function MetricDefinitions({ widget }: WidgetProps<"metric_definitions">) {
    const { groups } = widget.props;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {groups.map((group) => (
                <Box key={group.title}>
                    <CardLabel>{group.title}</CardLabel>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))" },
                            gap: 2,
                            mt: 1.5,
                        }}
                    >
                        {group.metrics.map((m) => (
                            <Card key={m.name} sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                {m.icon && (
                                    <Box component="img" src={m.icon} alt="" aria-hidden sx={{ width: 36, height: 36, mb: 0.5 }} />
                                )}
                                <Typography sx={{ fontSize: ds.text.lg, fontWeight: 700, color: ds.navy, lineHeight: 1.3 }}>
                                    {m.name}
                                </Typography>
                                <Typography sx={{ fontSize: ds.text.sm, color: ds.gray700, lineHeight: 1.55 }}>
                                    {m.description}
                                </Typography>
                                {m.better && (
                                    <Typography sx={{ mt: "auto", pt: 1, fontSize: ds.text.xs, fontWeight: 600, color: ds.gray500 }}>
                                        {m.better === "higher" ? "Better when higher" : m.better === "lower" ? "Better when lower" : m.better}
                                    </Typography>
                                )}
                            </Card>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
